module.exports = __webpack_public_path__ + "img/Girl_030017.15c28b98.png";